export default __webpack_public_path__ + "static/continuity-40e2c07c4ad8fe8aef2e4765c1d906d0.mp3";